import { observable } from "mobx";

export enum PresenceState {
	ONLINE = "ONLINE",
	OFFLINE = "OFFLINE",
	CONNECTION_PROBLEM = "CONNECTION_PROBLEM",
}

export interface IUserPresenceState {
	dscid: number;
	dscaid: number;
	presence: PresenceState;
	note: string;
	updated: number;
}

export class PresenceStore {
	@observable public myNote = "";
	@observable public userPresence = new Map<number, IUserPresenceState>();

	constructor() {
		setTimeout(() => {
			this.myNote = "ddd";
		}, 500);
	}

	public handleMqttMessage(topic: string, msg: any): void {
		switch (msg.type) {
			case "event":
				if (msg.data.presence === PresenceState.OFFLINE) {
					this.userPresence.delete(msg.data.dscaid);
				} else {
					this.userPresence.set(msg.data.dscaid, msg.data);
				}
				break;
			case "state":
				let userPresence = new Map();
				for (let presence of msg.data) {
					userPresence.set(presence.dscaid, presence);
				}
				this.userPresence = userPresence;
				break;
			default: console.log("unknown MQTT:", topic, msg.apiVersion, msg.type); break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/lib/stores/PresenceStore.ts